import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Card, Col, Form, Icon, Input, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../styles/button.style'
import { useDeepEffect } from '../../utils/hooks'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../utils/services'
import axios from 'axios'
import API from '../../api/Http'
import * as EndPoints from '../../api/EndPoints'
import {
  updateBrand
} from '../../modules/brand'
const BrandProfile = ({ form, me }) => {
  const dispatch = useDispatch()
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')
  const [brandData, setBrandData] = useState([])
  const [characterCount, setcharacterCount] = useState(0)

  async function fetchBrandById(id) {
    try {
      const response = await API.get(EndPoints.BRAND + `/${id}`)
      setBrandData(response.data)
    } catch (err) {
      console.log(err)
    }
  }

  console.log(brandData)

  useDeepEffect(() => {
    fetchBrandById(me)
  }, [])

  useDeepEffect(() => {
    if (!_.isEmpty(brandData)) {
      setFieldsValue({
        caption: brandData.caption,
        link: brandData.link,
        name: brandData.name,
        sponsorTag: brandData.sponsorTag
      })
      setImageUrl(brandData.logo)
      if (!_.isNull(brandData.caption)) {
        setcharacterCount(brandData.caption.length)
      }
    }
    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [brandData])

  async function uploadBrandImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/brand/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )

      return res.data
    } catch (err) {
      return null
    }
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          caption: values.caption,
          link: values.link,
          name: values.name,
          sponsorTag: values.sponsorTag
        }

        if (values.image) {
          const img = await uploadBrandImage(values.image.file)
          data.image = img.url
          setImageUrl(img.url)
        } else {
          data.image = brandData.logo
        }

        if (!_.isEmpty(brandData)) {
          data.id = brandData.id
        }
        onOk(data)
      }
    })
  }
  const onOk = async (data) => {
    if (!_.isEmpty(brandData)) {
      await dispatch(updateBrand(data))
    }
  }

  return (
    <Card
      title="Brand Profile">
      <Form onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Brand Image">
          {getFieldDecorator(`image`, {
            rules: [
              {
                required: isNull(brandData),
                message: 'เลือกรูปภาพ'
              }
            ]
          })(
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
              onChange={handleChange}>
              {imageUrl ? (
                <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
              ) : (
                uploadButton
              )}
            </Upload>
          )}
        </Form.Item>
        <Form.Item label="Brand Name">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Brand Description">
          {getFieldDecorator(`caption`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input.TextArea autoSize={{ minRows: 4 }} maxLength={1000} onChange={(e) => setcharacterCount(e.target.value.length)} />)}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexDirection: 'column'
          }}>{characterCount}/1000</div>
        </Form.Item>
        <Form.Item label="Brand Website">
          {getFieldDecorator(`link`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Sponsor">
          {getFieldDecorator(`sponsorTag`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

const WrappedBrandProfile = Form.create({ name: 'BrandProfile' })(BrandProfile)
export default WrappedBrandProfile



// WEBPACK FOOTER //
// ./src/pages/BrandProfile/index.js